import axios from 'axios';
import { debounce } from 'lodash';
import {add2basket} from './basket';
import {rootUrl} from './config';
import {bindAdd2BasketEvent} from './main'

function bindSearchEvents(){
  $("div.product-more-btn button[name='more_products']").on("click", function(evt){
    loadMoreProducts(this);
  });
  $("div.article-more-btn button[name='search_more_articles']").on("click", function(evt){
    loadMoreArticles(this);
  });
  let cHeight=$("#product_search .product-search-container").height()-10;
  $("#product_search .facet-container.products-type").css({"height": `${cHeight}px`});
  $("div.checkbox-facet[name='category'] div.folding-item div.facet-item").on("click", function(e) {
    e.preventDefault();
    e.stopPropagation();
    if ($(this).children("input").is(":checked")) {
      $(this).children("input").removeAttr("checked")
    } else {
      $(this).children("input").attr("checked", true)
    }
    if ($(this).parents(".mb-facet-container").length) return false;
    filterProductByCategory(this);
  })
  $("input[name='category']").on("click", function(e) {
    e.stopPropagation();
    return false;
  })
  $("div.expand-facet button.toggle-facet-btn").on("click", function(){
    toggleFacet(this);
  })
  $("div.range-facet div.apply-price button.apply-btn").on("click", function() {
    filterProductByPriceRange();
  })
  $("div.clear-all-filter button").on("click", function() {
    clearAllFilter(this);
  })
  $("div.mb-facet-container div.mb-fc-drawer div.mb-fc-header div.close, div.mb-overlay").on("click", function() {
    if ($("div.mb-facet-container div.mb-fc-drawer").attr("visible")) {
      toggleFilterDrawer(false);
    } else toggleFilterDrawer(true);
  })
  $("div.mb-fc-action div.apply-all-facet button").on("click", function() {
    applyAllFacet(this);
  })
  $("div.facet-container div.range-facet div.sugguested-price div.chip").on("click", function() {
    filterProductBySugguestedPriceRange(this);
  })
  $("div.mb-facet-container div.range-facet div.sugguested-price div.chip").on("click", function() {
    handleSugguestedMobileDrawer(this);
  })
  bindMobileFilterEvent();
  bindFilteredItemEvent();
  bindMBFilteredItemEvent();
  bindSearchInputEvents();
}

function sortByProduct(ele){
  let url=`${rootUrl}/search/sortbyproduct`;
  let params = {
    keyword: $("input[name='search_keyword']").val(),
    sortby: $(ele).data("sortby"),
    ft: $("#product_search input[name='search_keyword']").val()
  };
  
  axios({url:url,method:'POST',data: params}).then(function(res) {
    console.log(res.data);
    if(res.data.status && res.data.html){
      $("#product_search .product-search-container .product-cell").remove();
      $(res.data.html).insertAfter($("#product_search .product-search-container .sort-container")).find("button.btn-addcart").on("click",function(evt){
        evt.stopPropagation();
        add2basket(this,$(this).data("pid"),"search-more");
      });
      $("input[name='ploaded_page']").val(res.data.page);
      if(!res.data.isMore) $("#product_search div.product-more-btn").addClass("hide");
    }
  }).catch(function(err){
    console.log(err);
  });
}

function loadMoreProducts(ele){
  let url=`${rootUrl}/search/moreproduct`;
  let params = $(ele).data("para");
  params.page = $("input[name='ploaded_page']").val();
  params.price_of_last_product = $("input[name='price_of_last_product']").val();
  params.last_product_id = $("input[name='last_product_id']").val();
  axios({url:url,method:'POST',data: params}).then(function(res) {
    console.log(res.data);
    if(res.data.status && res.data.html){
      $(res.data.html).insertBefore($(ele).closest("div.product-more-btn")).find("button.btn-addcart").on("click",function(evt){
        evt.stopPropagation();
        if(!$(this).hasClass("read-more")) add2basket(this,$(this).data("pid"),"search-more");
        else {
          location.href=$(this).closest(".product-wrapper").find("a.product-url").attr("href");
        }
      });
      updateProductPageInc(res.data.page);
      if(!res.data.isMore) $(ele).closest("div.product-more-btn").addClass("hide");
      if(res.data.priceOfLastProduct) {
        $("input[name='price_of_last_product']").val(res.data.priceOfLastProduct);
      }
      if(res.data.lastProductId) {
        $("input[name='last_product_id']").val(res.data.lastProductId);
      }
    }
  }).catch(function(err){
    console.log(err);
  });
}

function updateProductPageInc(pageNum) {
  $("input[name='ploaded_page']").val(pageNum);
  // Sort items
  $("div.sort-container ul>li.sort-item a").each(function(idx){
    let href = $(this).attr('href');
    href = String(href).replace(/page\=\d+$/gi,`page=${pageNum}`);
    //console.log(href);
    $(this).attr('href',href);
  });
  $("div.facet-container .articles-category ul>li a").each(function(idx){
    let href = $(this).attr('href');
    href = String(href).replace(/page\=\d+$/gi,`page=${pageNum}`);
    //console.log(href);
    $(this).attr('href',href);
  });
}

function updateArticlePageInc(pageNum) {
  $("input[name='aloaded_page']").val(pageNum);
  // Sort items
  $("div.sort-container ul>li.sort-item a").each(function(idx){
    let href = $(this).attr('href');
    href = String(href).replace(/ap\=\d+/gi,`ap=${pageNum}`);
    //console.log(href);
    $(this).attr('href',href);
  });
  $("div.facet-container .products-type ul>li a").each(function(idx){
    let href = $(this).attr('href');
    href = String(href).replace(/ap\=\d+/gi,`ap=${pageNum}`);
    //console.log(href);
    $(this).attr('href',href);
  });
}

function loadMoreArticles(ele){
  let url=`${rootUrl}/search/morearticle`;
  let params = $(ele).data("para");
  params.page = $("input[name='aloaded_page']").val();
  axios({url:url,method:'POST',data: params}).then(function(res) {
    console.log(res.data);
    if(res.data.status && res.data.html){
      $(res.data.html).insertBefore($(ele).closest("div.article-more-btn"));
      updateArticlePageInc(res.data.page);
      if(!res.data.isMore) $(ele).closest("div.article-more-btn").addClass("hide");
    }
  }).catch(function(err){
    console.log(err);
  });
}
function filterProductByType(ele){
  let url=`${rootUrl}/search/filterproduct`;
  let params = {
    keyword: $("input[name='search_keyword']").val(),
    ft: $(ele).data("id"),
    limit: $(ele).data("limit")
  };
  
  axios({url:url,method:'POST',data: params}).then(function(res) {
    console.log(res.data);
    if(res.data.status && res.data.html){
      $("#product_search .product-search-container .product-cell").remove();
      $(res.data.html).insertAfter($("#product_search .product-search-container .sort-container")).find("button.btn-addcart").on("click",function(evt){
        evt.stopPropagation();
        add2basket(this,$(this).data("pid"),"search-more");
      });
      $("input[name='ploaded_page']").val(res.data.page);
      if(!res.data.isMore) $("#product_search div.product-more-btn").addClass("hide");
    }
  }).catch(function(err){
    console.log(err);
  });
}

function filterArticleByCategory(ele){
  let url=`${rootUrl}/search/filterarticle`;
  let params = {
    filter: {
      active: 1,
      keyword: $("input[name='search_keyword']").val()
    },
    fc: $(ele).data("id"),
    limit: $(ele).data("limit")
  };
  
  axios({url:url,method:'POST',data: params}).then(function(res) {
    console.log(res.data);
    if(res.data.status && res.data.html){
      $("#article_search .article-search-container .content-mainbox").remove();
      $(res.data.html).insertAfter($("#article_search .article-search-container .title"));
      $("input[name='aloaded_page']").val(res.data.page);
      if(!res.data.isMore) $("#article_search div.article-more-btn").addClass("hide");
    }
  }).catch(function(err){
    console.log(err);
  });
}

function filterProductByCategory() {
  let params = getParamsForFilter();
  let url=`${rootUrl}/searchxhr`;
  $("div.checkbox-facet").css("opacity","0.5").css("cursor","progress")
  $("div.checkbox-facet div.folding-item").css("pointer-events","none")
  axios({url:url,method:'GET', params: params}).then(function(res) {
    if(res.data.status && res.data.html){
      $("div.product-search-container").replaceWith($(res.data.html).find(".product-search-container"));
      bindAdd2BasketEvent();
      $("div.product-more-btn button[name='more_products']").on("click", function(evt){
        loadMoreProducts(this);
      });
      bindFilteredItemEvent();
      bindMBFilteredItemEvent();
    }
  }).catch(function(err){
    console.log(err);
  }).then(function() {
    $("div.checkbox-facet div.folding-item").css("pointer-events","unset")
    $("div.checkbox-facet").css("cursor","unset").css("opacity","unset")
    updateUrlWithoutReload(params)
  });
}
function toggleFacet(ele) {
  if (!$(ele).attr("is-expanding")) {
    $(ele).parent().siblings(".folding-item").find("div.facet-item[name='hidenItem']").css("display", "block");
    $(ele).attr("is-expanding", true)
    $(ele).html("Thu gọn")
  } else {
    $(ele).parent().siblings(".folding-item").find("div.facet-item[name='hidenItem']").css("display", "none");
    $(ele).removeAttr("is-expanding");
    $(ele).html("Xem thêm")
  }
}

function filterProductByPriceRange() {
  $("div.facet-container div.sugguested-price div.chip").removeAttr("checked");
  $("div.facet-container div.sugguested-price div.chip").removeClass("selected");
  let params = getParamsForFilter();
  $("div.range-facet").css("cursor","progress")
  $("div.range-facet div.range-of-price").css("opacity","0.5").css("pointer-events","none")
  $("div.range-facet div.apply-price").css("opacity","0.5").css("pointer-events","none")
  $("div.facet-container div.sugguested-price div.chip").css("opacity","0.5").css("pointer-events","none")
  let url=`${rootUrl}/searchxhr`;
  axios({url:url,method:'GET', params: params}).then(function(res) {
    if(res.data.status && res.data.html){
      $("div.product-search-container").replaceWith($(res.data.html).find(".product-search-container"));
      bindAdd2BasketEvent();
      $("div.product-more-btn button[name='more_products']").on("click", function(evt){
        loadMoreProducts(this);
      });
      bindFilteredItemEvent();
      bindMBFilteredItemEvent();
    }
  }).catch(function(err){
    console.log(err);
  }).then(function() {
    $("div.range-facet").css("cursor","unset")
    $("div.range-facet div.range-of-price").css("opacity","unset").css("pointer-events","unset")
    $("div.range-facet div.apply-price").css("opacity","unset").css("pointer-events","unset")
    $("div.facet-container div.sugguested-price div.chip").css("opacity","unset").css("pointer-events","unset")
    updateUrlWithoutReload(params)
  });
}

function updateUrlWithoutReload(params){
  let newUrl = `${rootUrl}/search?`;
  let count = 0;
  for (var i in params) {
    if (count === 0) {
      newUrl += `${i}=${String(params[i]).trim()}`
    } else {
      newUrl += `&${i}=${String(params[i]).trim()}`
    }
    count+=1;
  }
  window.history.pushState(
    {},
    null,
    newUrl
  )
}

function getParamsForFilter(fromDrawer){
  let params = {
    q: $("input[name='search_keyword']").val(),
    sortby: $("input[name='sortby']").val(),
    from: $("input[name='from']").val(),
    page: $("input[name='page']").val()
  }
  //for category
  let checkedCategories = [];
  let setOfElement = fromDrawer ? $("div.mb-facet-container input[name='category']:checked") : $("div.facet-container input[name='category']:checked");
  for (var i in setOfElement) {
    if (setOfElement[i].value && setOfElement[i].value != "")
      checkedCategories.push(setOfElement[i].value)
  }
  if (checkedCategories.length) params.category = String(checkedCategories);
  //for range of price
  let priceRangeFrom = fromDrawer ? $("div.mb-facet-container input[name='from_price']").val() : $("div.facet-container input[name='from_price']").val();
  let priceRangeTo = fromDrawer ? $("div.mb-facet-container input[name='to_price']").val() : $("div.facet-container input[name='to_price']").val();
  if (priceRangeFrom) params.price_range_from = priceRangeFrom;
  if (priceRangeTo) params.price_range_to = priceRangeTo;
  //for sugguested price range
  let suggestedPrice = fromDrawer ? $("div.mb-facet-container div.sugguested-price div.chip[checked]") : $("div.facet-container div.sugguested-price div.chip[checked]");
  if (suggestedPrice.length) {
    priceRangeFrom = suggestedPrice.data("from");
    priceRangeTo = suggestedPrice.data("to");
    if (priceRangeFrom) params.price_range_from = priceRangeFrom;
    if (priceRangeTo) params.price_range_to = priceRangeTo;
  }
  return params;
}
function clearAllFilter(ele) {
  let params = getParamsForFilter();
  delete params.category;
  delete params.price_range_from;
  delete params.price_range_to;
  let url=`${rootUrl}/searchxhr`;
  $(ele).parent().css("cursor","progress").css("opacity","0.5");
  $(ele).css("pointer-events","none")
  axios({url:url,method:'GET', params: params}).then(function(res) {
    if(res.data.status && res.data.html){
      $("div.product-search-container").replaceWith($(res.data.html).find(".product-search-container"));
      bindAdd2BasketEvent();
      $("div.product-more-btn button[name='more_products']").on("click", function(evt){
        loadMoreProducts(this);
      });
      bindFilteredItemEvent();
      bindMBFilteredItemEvent();
    }
  }).catch(function(err){
    console.log(err);
  }).then(function() {
    $(ele).parent().css("cursor","unset").css("opacity","unset");
    $(ele).css("pointer-events","unset")
    $("input[name='category']").removeAttr("checked");
    $("input[name='from_price'], input[name='to_price']").val("");
    updateUrlWithoutReload(params)
  });
}
function applyAllFacet(ele) {
  const FROM_DRAWER = true;
  let params = getParamsForFilter(FROM_DRAWER);
  let url=`${rootUrl}/searchxhr`;
  $(ele).css("opacity", "0.5").css("pointer-events", "none");
  axios({url:url,method:'GET', params: params}).then(function(res) {
    if(res.data.status && res.data.html){
      $("div.product-search-container").replaceWith($(res.data.html).find(".product-search-container"));
      bindAdd2BasketEvent();
      $("div.product-more-btn button[name='more_products']").on("click", function(evt){
        loadMoreProducts(this);
      });
      bindFilteredItemEvent();
      bindMBFilteredItemEvent();
    }
  }).catch(function(err){
    console.log(err);
  }).then(function() {
    $(ele).css("opacity", "unset").css("pointer-events", "unset");
    updateUrlWithoutReload(params)
    toggleFilterDrawer(false);
    bindMobileFilterEvent();
  });
}
function toggleFilterDrawer(state) {
  if (state) {
    $("div.mb-facet-container div.mb-overlay").css("display", "block");
    $("div.mb-facet-container div.mb-fc-drawer").css("display", "block");
    $("div.mb-facet-container div.mb-fc-drawer").animate({ "right": "+=300px" },"slow")
    $("div.mb-facet-container div.mb-fc-drawer").attr("visible", true);
  } else {
    $("div.mb-facet-container div.mb-overlay").css("display", "none");
    $("div.mb-facet-container div.mb-fc-drawer").animate({ "right": "-=300px" },"slow", function() {
      $("div.mb-facet-container div.mb-fc-drawer").css("display", "none");
    })
    $("div.mb-facet-container div.mb-fc-drawer").removeAttr("visible");
  }
}
function bindMobileFilterEvent() {
  $("div.mb-filter-toggle button").on("click", function() {
    if (!$("div.mb-facet-container div.mb-fc-drawer").attr("visible")) {
      toggleFilterDrawer(true);
    } else toggleFilterDrawer(false);
  })
}
function filterProductBySugguestedPriceRange(ele) {
  if (!$(ele).attr("checked")) {
    $("div.facet-container div.sugguested-price div.chip").removeAttr("checked");
    $(ele).attr("checked", true);
    $("div.facet-container div.sugguested-price div.chip").removeClass("selected");
    $(ele).addClass("selected");
    $("div.facet-container input[name='from_price']").val($(ele).data("from"))
    $("div.facet-container input[name='to_price']").val($(ele).data("to"))
  } else {
    $("div.facet-container div.sugguested-price div.chip").removeAttr("checked");
    $("div.facet-container div.sugguested-price div.chip").removeClass("selected");
    $("div.facet-container input[name='from_price']").val("")
    $("div.facet-container input[name='to_price']").val("")
  }
  let params = getParamsForFilter();
  $("div.range-facet").css("cursor","progress")
  $("div.range-facet div.range-of-price").css("opacity","0.5").css("pointer-events","none")
  $("div.range-facet div.apply-price").css("opacity","0.5").css("pointer-events","none")
  $("div.facet-container div.sugguested-price div.chip").css("opacity","0.5").css("pointer-events","none")
  let url=`${rootUrl}/searchxhr`;
  axios({url:url,method:'GET', params: params}).then(function(res) {
    if(res.data.status && res.data.html){
      $("div.product-search-container").replaceWith($(res.data.html).find(".product-search-container"));
      bindAdd2BasketEvent();
      $("div.product-more-btn button[name='more_products']").on("click", function(evt){
        loadMoreProducts(this);
      });
      bindFilteredItemEvent();
      bindMBFilteredItemEvent();
    }
  }).catch(function(err){
    console.log(err);
  }).then(function(){
    $("div.range-facet").css("cursor","unset")
    $("div.range-facet div.range-of-price").css("opacity","unset").css("pointer-events","unset")
    $("div.range-facet div.apply-price").css("opacity","unset").css("pointer-events","unset")
    $("div.facet-container div.sugguested-price div.chip").css("opacity","unset").css("pointer-events","unset")
    updateUrlWithoutReload(params)
  });
}
function handleSugguestedMobileDrawer(ele) {
  if (!$(ele).attr("checked")) {
    $("div.mb-facet-container div.sugguested-price div.chip").removeAttr("checked");
    $(ele).attr("checked", true);
    $("div.mb-facet-container div.sugguested-price div.chip").removeClass("selected");
    $(ele).addClass("selected");
    $("div.mb-facet-container input[name='from_price']").val($(ele).data("from"))
    $("div.mb-facet-container input[name='to_price']").val($(ele).data("to"))
  } else {
    $("div.mb-facet-container div.sugguested-price div.chip").removeAttr("checked");
    $("div.mb-facet-container div.sugguested-price div.chip").removeClass("selected");
    $("div.mb-facet-container input[name='from_price']").val("")
    $("div.mb-facet-container input[name='to_price']").val("")
  }
}
function bindFilteredItemEvent() {
  $("div.filtered-items div.item span.remove-filter").on("click", function(e) {
    e.preventDefault();
    e.stopPropagation();
    let itemId = $(this).data("ref");
    if (itemId && itemId != "") {
      $(`div.facet-container div[data-ref='${itemId}']`).click();
    }
  })
}
function bindMBFilteredItemEvent() {
  $("div.mb-filtered-items div.item span.remove-filter").on("click", function(e) {
    e.preventDefault();
    e.stopPropagation();
    let itemId = $(this).data("ref");
    if (itemId && itemId != "") {
      $(`div.mb-facet-container div[data-ref='${itemId}']`).click();
      let params = getParamsForFilter(true);
      let url=`${rootUrl}/searchxhr`;
      axios({url:url,method:'GET', params: params}).then(function(res) {
        if(res.data.status && res.data.html){
          $("div.product-search-container").replaceWith($(res.data.html).find(".product-search-container"));
          bindAdd2BasketEvent();
          $("div.product-more-btn button[name='more_products']").on("click", function(evt){
            loadMoreProducts(this);
          });
          bindFilteredItemEvent();
          bindMBFilteredItemEvent();
        }
      }).catch(function(err){
        console.log(err);
      }).then(function() {
        updateUrlWithoutReload(params)
        bindMobileFilterEvent();
      });
    }
  })
}
function bindSearchInputEvents() {
  const ARROW_UP = 38, ARROW_DOWN = 40, ENTER = 13;
  let currentHoverRow = -1;
  let curentSearchText = "";
  $("input.search-input").keyup(debounce(function(e) {
    if (e.which != ARROW_UP && e.which != ARROW_DOWN && e.which != ENTER) {
      curentSearchText = $($("input.search-input")).val();
      let url=`${rootUrl}/suggest/`;
      let keyword = $(this).val();
      if (!keyword || keyword == "" || keyword.length < 2) {
        $("div.suggestion-box").children().remove();
        return false;
      }
      axios({url:url+keyword,method:'GET'}).then(function(res) {
        if (!res.data || !res.data.rows) return false;
        $("div.suggestion-box").children().remove();
        for (var i in res.data.rows) {
          $("div.suggestion-box").append(
            `<a href="/search?q=${res.data.rows[i].href}"
            data-org-text="${res.data.rows[i].value}"
            class="suggested-row">${res.data.rows[i].text}</a>`
          )
        }
        currentHoverRow = -1;
      }).catch(function(err){
        console.log(err);
      });
    }
  }, 300));
  $("input.search-input").keyup(function(e) {
    let rows = $("div.suggestion-box").children();
    if (!rows || !rows.length) return false;
    switch (e.which) {
      case ARROW_UP:
        unhoverAllSuggestedRow();
        if (currentHoverRow == -1) currentHoverRow = rows.length - 1;
        else currentHoverRow -= 1;
        if (currentHoverRow != -1) hoverSuggestedRow(rows[currentHoverRow]);
        else $("input.search-input").val(curentSearchText)
        break;
      case ARROW_DOWN:
        unhoverAllSuggestedRow();
        if (currentHoverRow == rows.length - 1) currentHoverRow = -1;
        else currentHoverRow += 1;
        if (currentHoverRow != -1) hoverSuggestedRow(rows[currentHoverRow]);
        else $("input.search-input").val(curentSearchText)
        break;
      default:
        break;
    }
  })
  $("input.search-input").on("focus", function() {
    $("div.suggestion-box").css("display", "flex");
  })
  $("input.search-input").on("blur", function() {
    if ($('div.suggestion-box:hover').length != 0) return false;
    $("div.suggestion-box").css("display", "none");
  })
}
function hoverSuggestedRow(ele) {
  let suggestedText = $(ele).data("org-text");
  $("input.search-input").val(suggestedText);
  $(ele).css("background-color","rgba(0,0,0,0.02)");
}
function unhoverAllSuggestedRow() {
  $("div.suggestion-box").children().css("background-color", "unset");
}

window.addEventListener("popstate", function(e) {
  window.location.href = location.href;
});

export {bindSearchEvents};